var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8351 31.6701C24.5805 31.6701 31.6701 24.5805 31.6701 15.8351C31.6701 7.08962 24.5805 0 15.8351 0C7.08962 0 0 7.08962 0 15.8351C0 24.5805 7.08962 31.6701 15.8351 31.6701Z",
    fill: "url(#paint0_linear_45_77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89731 16.6099C7.74842 15.5902 9.81476 14.7392 11.7454 13.8839C15.067 12.4829 18.4017 11.1061 21.7701 9.82442C22.4255 9.60603 23.603 9.39245 23.7185 10.3637C23.6553 11.7384 23.3952 13.1051 23.2168 14.4718C22.7639 17.4773 22.2406 20.4725 21.7302 23.4681C21.5544 24.4659 20.3044 24.9825 19.5046 24.3439C17.5825 23.0456 15.6456 21.7599 13.7481 20.4315C13.1265 19.7998 13.7029 18.8928 14.258 18.4418C15.8411 16.8816 17.52 15.5561 19.0204 13.9153C19.4251 12.938 18.2293 13.7617 17.8349 14.014C15.6676 15.5076 13.5533 17.0922 11.2684 18.4048C10.1012 19.0473 8.74081 18.4983 7.57417 18.1397C6.52811 17.7066 4.99527 17.2703 5.89721 16.6099L5.89731 16.6099Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_77",
    x1: 11.8781,
    y1: 1.32064,
    x2: 3.96061,
    y2: 19.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4eb80341c187ff35298c22bc4424bace.svg";
export { ForwardRef as ReactComponent };